import { motion } from 'framer-motion';
import React, { ReactElement } from 'react';

function InnerDivider(): ReactElement {
  return (
    <motion.div
      initial={{ width: '10px' }}
      animate={{ width: 'auto' }}
      className={`border-t border-black my-6 lg:my-7 xl:my-8" : "py-6 lg:py-7 xl:py-8"`}
    />
  );
}

export default InnerDivider;
